/**
 * `@compass/client` — the shared, proto-generated Compass API client.
 *
 * Everything under `types/`, `services/` and `constants/` is generated from the protos
 * in `/proto` by `make tstypes` (or `pnpm gen`), which runs `scripts/types-gen.sh`:
 * ts-proto emits the types, `extract-permissions.go` the constants, and
 * `generate-services.js` the transport-injected service factories. Do not hand-edit those;
 * change the proto and regenerate. See `ui/compass-client/CLAUDE.md`.
 *
 * ## Usage
 *
 * ```typescript
 * import { createServices, type Transport } from '@compass/client';
 *
 * const transport: Transport = { ... };          // your app's adapter
 * const { userService, caseRecordService } = createServices(transport);
 *
 * const me = await userService.getCurrentUser({});
 * ```
 *
 * Request/response types are imported per-module to avoid collisions between the ~55
 * generated type files:
 *
 * ```typescript
 * import type { GetUserRequest } from '@compass/client/types/user';
 * ```
 */

export {
  type RequestOptions,
  type StreamOptions,
  type Transport,
  TransportCapabilityError,
  requirePostForm,
  requireStream,
} from './transport';

export { getApiPath } from './path';

export { API_METHODS } from './constants/api-methods';

export * from './services';
